import React from 'react';
import { getActivityTimeLabel } from './activityDateUtils';

const MEDIUM_META = {
    EMAIL: { icon: 'bi-envelope-fill', className: 'activity-medium--email' },
    SMS: { icon: 'bi-chat-text-fill', className: 'activity-medium--sms' },
    CALL: { icon: 'bi-telephone-fill', className: 'activity-medium--call' },
};

const STATUS_META = {
    SENT: { className: 'activity-status--sent', icon: 'bi-check-circle-fill', label: 'Sent' },
    DELIVERED: { className: 'activity-status--delivered', icon: 'bi-check2-all', label: 'Delivered' },
    OPENED: { className: 'activity-status--opened', icon: 'bi-envelope-open-fill', label: 'Read' },
    FAILED: { className: 'activity-status--failed', icon: 'bi-x-circle-fill', label: 'Failed' },
    ERROR: { className: 'activity-status--error', icon: 'bi-exclamation-circle-fill', label: 'Error' },
    BOUNCED: { className: 'activity-status--bounced', icon: 'bi-exclamation-octagon-fill', label: 'Bounced' },
    QUEUED: { className: 'activity-status--queued', icon: 'bi-hourglass-split', label: 'Queued' },
    WAITING: { className: 'activity-status--waiting', icon: 'bi-clock-history', label: 'Waiting' },
    RESEND: { className: 'activity-status--resend', icon: 'bi-arrow-repeat', label: 'Resend' },
};

function ActivityStatusBadge({ status }) {
    const meta = STATUS_META[status] || STATUS_META.WAITING;

    return (
        <span className={`activity-status ${meta.className}`}>
            <i className={`bi ${meta.icon}`}></i>
            {meta.label || status || 'UNKNOWN'}
        </span>
    );
}

function ActivityMediumBadge({ mediumType }) {
    const meta = MEDIUM_META[mediumType] || { icon: 'bi-question-circle', className: 'activity-medium--default' };

    return (
        <span className={`activity-medium ${meta.className}`}>
            <i className={`bi ${meta.icon}`}></i>
            {mediumType || 'Unknown'}
        </span>
    );
}

function ActivityListItem({ item, onViewDetails }) {
    const timeLabel = getActivityTimeLabel(item.createdAt);

    return (
        <article className="activity-item ecx-page-list-item">
            <div className="activity-item__row">
                <span className="ecx-page-icon-badge activity-item__icon">
                    <i className={`bi ${MEDIUM_META[item.mediumType]?.icon || 'bi-activity'}`}></i>
                </span>

                <div className="activity-item__title" title={item.activityName || 'Untitled activity'}>
                    {item.activityName || 'Untitled activity'}
                </div>

                <div className="activity-item__meta">
                    <ActivityStatusBadge status={item.status} />
                    <ActivityMediumBadge mediumType={item.mediumType} />
                    <button
                        type="button"
                        className="btn btn-sm btn-outline-secondary"
                        onClick={() => onViewDetails(item)}
                    >
                        <i className="bi bi-eye me-1"></i>
                        Details
                    </button>
                    <time className="activity-item__time" dateTime={item.createdAt || undefined} title={item.createdAt || undefined}>
                        {timeLabel}
                    </time>
                </div>
            </div>
        </article>
    );
}

export default ActivityListItem;
